import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/modules/material/material-module.module';
import { CodeVerifyComponent } from './code-verify/code-verify.component';
import { MfaEnrollComponent } from './mfa-enroll.component';
import { PreInitComponent } from './pre-init/pre-init.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { SuccessOrErrorComponent } from './success-or-error/success-or-error.component';

@NgModule({
  declarations: [
    MfaEnrollComponent,
    PreInitComponent,
    SuccessOrErrorComponent,
    QrCodeComponent,
    CodeVerifyComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    MfaEnrollComponent,
    PreInitComponent,
    SuccessOrErrorComponent,
    QrCodeComponent,
    CodeVerifyComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MfaEnrollModule {}
